import { useIllustrationColor } from '../hooks/useIllustrationColor.hook';
import type { IllustrationProps } from '../types/props.type';

// https://undraw.co/search/essay-writing
export const EssayWritingIllustration = ({
  color: pColor,
  title = 'Rédaction',
}: Readonly<IllustrationProps>) => {
  const color = useIllustrationColor(pColor);

  return (
    <svg
      height="559.94"
      role="img"
      viewBox="0 0 960 559.94"
      width="960"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <g transform="translate(-666.606 -418.401)">
        <path
          d="M206.59,598.162c10.5,37.673,21.969,73.351,34.31,106.778l891.38,3.689c12.34-33.428,23.8-69.1,34.31-106.781Z"
          fill="#f2f2f2"
          transform="translate(460.016 378.717)"
        />
        <path
          d="M398.28,505.314V725.334H552.423V505.314a7.4,7.4,0,0,0-5.213-7.08,6.811,6.811,0,0,0-2.21-.343H405.723A7.43,7.43,0,0,0,398.28,505.314Zm60.162,75.6a16.455,16.455,0,1,1,32.91,0v25.537a16.455,16.455,0,0,1-32.91,0Z"
          fill="#2f2e41"
          transform="translate(514.387 263.874)"
        />
        <path
          d="M398.06,600.632V621.85a4.175,4.175,0,0,0,4.141,4.163H549.008a4.163,4.163,0,0,0,4.141-4.163V600.632Z"
          fill="#3f3d56"
          transform="translate(514.133 381.546)"
        />
        <path
          d="M285.25,357.131V758.866a19.322,19.322,0,0,0,19.3,19.307H899.892A19.322,19.322,0,0,0,919.2,758.866V357.131a19.333,19.333,0,0,0-19.307-19.292H304.553A19.332,19.332,0,0,0,285.25,357.131Z"
          fill="#3f3d56"
          transform="translate(384.929 80.561)"
        />
        <path
          d="M291.76,354.683v391.78a10.338,10.338,0,0,0,10.318,10.319h585.4A10.338,10.338,0,0,0,897.8,746.463V354.683a10.341,10.341,0,0,0-10.318-10.341h-585.4A10.341,10.341,0,0,0,291.76,354.683Z"
          fill="#fff"
          transform="translate(392.388 88.009)"
        />
        <path
          d="M343.173,631.072a6.326,6.326,0,0,0,4.972,2.378H696.42a6.41,6.41,0,0,0,6.262-7.723l-5.408-25.68a6.42,6.42,0,0,0-3.99-4.657,6.206,6.206,0,0,0-2.274-.43H353.531a6.209,6.209,0,0,0-2.274.43,6.418,6.418,0,0,0-3.99,4.657l-5.408,25.68A6.4,6.4,0,0,0,343.173,631.072Z"
          fill="#2f2e41"
          transform="translate(449.619 375.051)"
        />
        <g transform="translate(1038.4 454.934)">
          <rect
            fill="#e6e6e6"
            height="44.781"
            rx="16"
            transform="translate(0)"
            width="219.425"
          />
          <path
            d="M2.109,4.93V-17.46h7.927a8.241,8.241,0,0,1,3.866.8,5.359,5.359,0,0,1,2.267,2.148,6.063,6.063,0,0,1,.743,2.982,4.953,4.953,0,0,1-.51,2.382,4.133,4.133,0,0,1-1.343,1.5,6.24,6.24,0,0,1-1.809.826v.21a4.366,4.366,0,0,1,2.095.721,5.271,5.271,0,0,1,1.742,1.879,5.894,5.894,0,0,1,.7,2.976A6.006,6.006,0,0,1,17.011,2a5.328,5.328,0,0,1-2.425,2.142,10.008,10.008,0,0,1-4.293.784ZM4.962,2.405h5.255A5.472,5.472,0,0,0,13.932,1.4a3.209,3.209,0,0,0,1.1-2.463,3.943,3.943,0,0,0-.571-2.073,4.179,4.179,0,0,0-1.619-1.519,5.1,5.1,0,0,0-2.484-.571h-5.4Zm0-10.038H9.887a4.564,4.564,0,0,0,3.047-1.052,3.458,3.458,0,0,0,1.246-2.78,3.341,3.341,0,0,0-1.013-2.463,4.377,4.377,0,0,0-3.191-1.008H4.962Z"
            fill="#090814"
            transform="translate(24.759 28.656)"
          />
          <g transform="translate(85.083 11.146)">
            <path
              d="M9.272,18.423a1.254,1.254,0,0,1-.9-.382,1.324,1.324,0,0,1,0-1.843l7.636-7.816a1.252,1.252,0,0,1,1.8,0,1.324,1.324,0,0,1,0,1.843l-7.641,7.816a1.254,1.254,0,0,1-.9.382Z"
              transform="translate(-1.636 -1.965)"
            />
            <path
              d="M19.182,18.518a1.257,1.257,0,0,1-.962-.448,1.324,1.324,0,0,1,.125-1.838l.644-.573c2.107-2.19,3.089-6.753,1.244-8.643s-6.3-.886-8.441,1.271l-.56.661a1.253,1.253,0,0,1-1.791.134A1.324,1.324,0,0,1,9.31,7.245L9.9,6.539q.03-.036.063-.069a10.905,10.905,0,0,1,5.835-2.92,6.865,6.865,0,0,1,6.241,1.621,7.263,7.263,0,0,1,1.583,6.389,11.367,11.367,0,0,1-2.857,5.968q-.031.032-.065.063l-.68.6A1.251,1.251,0,0,1,19.182,18.518Z"
              transform="translate(-1.364 -3.362)"
            />
            <path
              d="M9.9,24.1a6.348,6.348,0,0,1-4.642-1.755A7.924,7.924,0,0,1,3,16.815c0-2.306,2.3-5.59,3.529-6.835l.054-.051.672-.6a1.253,1.253,0,0,1,1.791.112,1.324,1.324,0,0,1-.112,1.839l-.639.578c-1.208,1.231-2.75,3.846-2.75,4.958a5.271,5.271,0,0,0,1.5,3.68c1.853,1.875,6.314.9,8.487-1.237l.448-.612a1.254,1.254,0,0,1,1.781-.269,1.323,1.323,0,0,1,.259,1.82l-.5.7a1.3,1.3,0,0,1-.127.149,11.032,11.032,0,0,1-5.862,2.919A9.935,9.935,0,0,1,9.9,24.1Z"
              transform="translate(-3 -1.662)"
            />
          </g>
          <rect
            fill="#fff"
            height="44.781"
            transform="translate(120.908)"
            width="2.239"
          />
          <path
            d="M.773,4.356,3.512-11.909H6.177L3.439,4.356ZM5.3-14.572a1.556,1.556,0,0,1-1.215-.513,1.394,1.394,0,0,1-.336-1.223,1.929,1.929,0,0,1,.756-1.231,2.2,2.2,0,0,1,1.392-.5,1.584,1.584,0,0,1,1.231.5,1.4,1.4,0,0,1,.336,1.231,1.949,1.949,0,0,1-.758,1.223A2.2,2.2,0,0,1,5.3-14.572Z"
            transform="translate(59.681 29.229)"
          />
          <g transform="translate(136.581 11.195)">
            <path
              d="M2.239,0A2.239,2.239,0,1,1,0,2.239,2.239,2.239,0,0,1,2.239,0Z"
              fill="#090814"
              transform="translate(11.195 4.478)"
            />
            <path
              d="M6.478,2H19.912A4.478,4.478,0,0,1,24.39,6.478V19.912a4.478,4.478,0,0,1-4.478,4.478H6.478A4.478,4.478,0,0,1,2,19.912V6.478A4.478,4.478,0,0,1,6.478,2ZM19.912,22.151a2.239,2.239,0,0,0,2.239-2.239V6.478a2.239,2.239,0,0,0-2.239-2.239H6.478A2.239,2.239,0,0,0,4.239,6.478V19.912a2.239,2.239,0,0,0,2.239,2.239Z"
              transform="translate(-2 -2)"
            />
            <path
              d="M17.673,17.916a1.119,1.119,0,0,1-.791-.328L11.292,12A1.145,1.145,0,0,0,9.5,12l-5.59,5.59a1.119,1.119,0,1,1-1.583-1.583l5.6-5.6.016-.015a3.374,3.374,0,0,1,4.911,0l.016.015,5.6,5.6a1.12,1.12,0,0,1-.793,1.911Z"
              transform="translate(-2 -1.124)"
            />
            <path
              d="M21.956,17.677a1.119,1.119,0,0,1-.791-.328L17.814,14a1.145,1.145,0,0,0-1.791,0L14.911,15.11a1.119,1.119,0,1,1-1.583-1.583l1.12-1.119.016-.015a3.374,3.374,0,0,1,4.911,0l.016.015,3.359,3.359a1.12,1.12,0,0,1-.793,1.911Z"
              transform="translate(-0.685 -0.885)"
            />
          </g>
          <g transform="translate(176.883 11.199)">
            <path
              d="M7.079,27.39A3.14,3.14,0,0,1,4,24.191V14.6C4,9.59,6.54,6.29,11.323,5.048A1.536,1.536,0,0,1,13.19,6.211a1.6,1.6,0,0,1-1.12,1.94c-3.428.9-4.992,2.922-4.992,6.445v1.6H11.7a3.135,3.135,0,0,1,3.071,2.959l.008.24v4.8a3.14,3.14,0,0,1-3.079,3.2Z"
              transform="translate(9.855 -5.003)"
            />
            <path
              d="M16.079,27.39A3.14,3.14,0,0,1,13,24.191V14.6c0-5.005,2.54-8.3,7.323-9.547A1.536,1.536,0,0,1,22.19,6.212a1.6,1.6,0,0,1-1.12,1.94c-3.428.9-4.992,2.922-4.992,6.445v1.6H20.7a3.135,3.135,0,0,1,3.071,2.959l.008.24v4.8a3.14,3.14,0,0,1-3.079,3.2Z"
              transform="translate(-12.999 -5.003)"
            />
          </g>
        </g>
        <g transform="translate(885.443 541.866)">
          <path
            d="M527.3,624.116s166.464,20.075,150.569,0c-5.756-7.262-7.344-28.776-7.026-53.284.1-7.445.374-15.157.751-22.833,1.842-36.8,6.273-72.776,6.273-72.776S532.317,406.631,549.047,461c6.692,21.968,4.5,52.82-.586,81.776-1.489,8.45-3.212,16.73-5.02,24.594A576.513,576.513,0,0,1,527.3,624.116Z"
            fill="#ed9da0"
            transform="translate(-202.993 -311.727)"
          />
          <path
            d="M904.2,866.557v-1.4l-293.811-3.2-179.007-1.673h-.5l.188,2.476-.251-2.476H430.5V860l-2.292-22.5-.87-8.514-.267-2.66-.234-2.225L416.5,789.617l-10.34-34.43-8.7-28.992-13.284-44.3s7.527-17.568,11.717-22.585,20.6-40.937,20.6-40.937,23.452-32.4,39.054-36.3c6.54-1.672,19.458-3.9,33.176-6.692,5.136-1.038,44.5-12.406,46.842-13.985,12.3-9.013,43.112-10.038,44.3-10.038h0a.688.688,0,0,0,0-.119v-.15a17.1,17.1,0,0,1,0-2.1,13.428,13.428,0,0,1,.15-2.342,2.1,2.1,0,0,1,.119-.837c.084-.6.188-1.238.335-1.906a8.365,8.365,0,0,1,.2-.886,28.8,28.8,0,0,1,2.093-5.839c.117-.267.267-.553.4-.82a30.512,30.512,0,0,1,2.844-4.4c.218-.285.451-.586.7-.87a32.761,32.761,0,0,1,4.552-4.416c.45-.352.919-.72,1.4-1.052a7.788,7.788,0,0,1,.855-.6l1.489-.971,1.388-.8c1.221-.669,2.51-1.322,3.915-1.941.434-.2.9-.385,1.372-.562s1.2-.469,1.823-.7h.1l1.254-.5c.954-.318,1.924-.6,2.944-.886l1.556-.4,1.672-.385,1.674-.352c1.672-.335,3.462-.635,5.336-.87l1.906-.234,1.953-.2,2.025-.167,2.877-.167,3.345-.119A208.7,208.7,0,0,1,674.1,520.43a120.906,120.906,0,0,1,30.5-2.816h1.456l1.672.1H708.8l2.157.2a16.03,16.03,0,0,1,2.175.251c.72.1,1.472.188,2.192.3l1.1.188c1.088.188,2.192.385,3.345.617q.553.1,1.1.251c1.456.318,2.911.7,4.356,1.137.72.2,1.439.434,2.157.685a9.694,9.694,0,0,1,1.071.374l1.071.384,1.052.418,1.254.5c.635.267,1.254.553,1.873.855.352.15.7.318,1.038.5s.685.335,1,.518a46.413,46.413,0,0,1,10.389,7.328l.855.82.837.855c.284.285.553.586.82.886a39.883,39.883,0,0,1,3.045,3.764c.267.352.518.7.771,1.071a44.7,44.7,0,0,1,2.877,4.885c.218.4.418.82.617,1.221a54.69,54.69,0,0,1,3.345,8.783q.469,1.672.855,3.345s35.417,15.623,64.795,26.937c7.811,3,15.172,5.738,21.331,7.8,1.791.6,3.464,1.154,5.02,1.672a44.666,44.666,0,0,0,10.455,2.4,32.855,32.855,0,0,1,5.021.469c13.5,2.192,36.638,11.717,39.166,21.265a6.169,6.169,0,0,1,.167,2.342s55.025,170.362,55.63,173.49c2.435,12.748,7.867,37.023,10.539,46.842,1.99,7.328,4.885,17.365,6.875,24.257a2.342,2.342,0,0,0,.167.586l-75-.736v1.4H904.1Z"
            fill={color}
            transform="translate(-263.933 -260.775)"
          />
          <path
            d="M515.8,549.027c48.511,8.935,139.863,7.009,179.345,5.654-14.47-51.863-85.037-34.23-85.037-34.23C522.758,503.02,516.067,539.191,515.8,549.027Z"
            fill={color}
            transform="translate(-199.96 -260.762)"
          />
          <path
            d="M835.241,672.919s-57.149-8.783-58.271,16.312,29.142,42.627,29.142,42.627Z"
            fill="#ed9da0"
            transform="translate(-776.94 -156.005)"
          />
          <path
            d="M704.943,766.081s1.489,3.545,4.233,8.684A115.439,115.439,0,0,0,724.234,796.8l.451.485h2.7l96.6.886H826.3l.285-.335L845.312,775.6l7.06-8.382.284-.352.6-.7.335-.4.434-.518,13.734-16.3-5.02-20.913L854.195,692.8l-.218-.855-1.672-6.692-1.188-5.02-3.982-16.36-13.65-56.3-24.257,12.549L783.656,665.31l-13.733,24.257H762.4c-1.421,0-4.682,2.745-7.962,5.905-1.17,1.124-2.342,2.309-3.345,3.345-2.979,3.078-5.336,5.722-5.336,5.722s-12.195.267-15.472,9.871a11.706,11.706,0,0,0-.418,1.421,67.444,67.444,0,0,1-4.233,10.975c-2.157,4.7-4.87,10.037-7.612,15.373-5.107,9.787-10.288,19.1-12.195,22.477l-.234.418Z"
            fill={color}
            transform="translate(-689.018 -198.978)"
          />
          <path
            d="M909.742,776.507v-1.4l-293.811-3.2-179.01-1.673h-.5v-.285l-1.672-22.477-.72-10.038L431.283,699.6l-2.157-29.946v-.736a17.759,17.759,0,0,1,.188-4.132.5.5,0,0,1,0-.167,17.388,17.388,0,0,1,3.345-7.762,17.633,17.633,0,0,1,15.759-6.692c20.261,2.076,40.72,3.731,61.2,5.02q4.192.3,8.366.518c132.067,7.846,262.944,1.489,333.763-3.345l5.02-.374c12.262-.871,22.518-1.673,30.415-2.358a17.633,17.633,0,0,1,18.8,14.271,18.45,18.45,0,0,1,.3,2.745l1.137,37.074,1.556,46.961.736,24.024v1.873Z"
            fill="#090814"
            transform="translate(-269.474 -170.722)"
          />
          <circle
            cx="96.905"
            cy="96.905"
            fill="#ed9da0"
            r="96.905"
            transform="translate(324.526 46.94)"
          />
          <path
            d="M544.833,440.592A8.176,8.176,0,0,1,550.682,438l-1.457-4.045a7.679,7.679,0,0,1,8.616-10.215l5.306,1.023-.5-3.545a7.679,7.679,0,0,1,10.287-8.307,8.192,8.192,0,0,0,7.047-.5,8.364,8.364,0,0,0,4.175-5.677L586,397.822l.188-.478c9-15.007,26.315-25.923,47.5-29.926,18.855-3.589,38.19-1.761,56.829-.044,7.4.7,15.744,1.48,22.705,5.741,5.916,3.655,10.918,10.966,9.895,18.327,18.376-5.632,38.08,5.62,47.846,19.791,11.567,16.875,13.461,38.023,13.767,54.543.826,39.1-7.244,71.1-23.922,95.1-1.217,1.739-1.523,5.372-3.933,6.59l.5-.805c-2.7,1.352-5.432,3.523-4.415,5.849,2.935,6.7-16.572,21.508-30.317,26.41-25.076,8.938-58.415,8.178-81.852,4.957l-.826-5.546c-8.46-1.152-14.421-3.348-16.093-6.785-2.958-2.524-5.48-4.784-7.679-6.872l-.023-.023c-.044-.043-.131-.108-.174-.15-10.592-10.156-13.049-15.941-14.158-24.748-1.065-8.635.826-17.4,2.763-25.286-40.756,6.309,16.051-43.413-21.915-53.027a11.847,11.847,0,0,0-1.326-.326c-1.109-.26-2.217-.523-3.284-.826a57.5,57.5,0,0,1-14.61-6.242c-10.613-6.459-14.12-15.022-19.6-24.684a7.451,7.451,0,0,1,.978-8.764Z"
            fill="#090814"
            transform="translate(-227.04 -365.354)"
          />
        </g>
        <path
          d="M12,0H168a12,12,0,0,1,12,12v7a12,12,0,0,1-12,12H12A12,12,0,0,1,0,19V12A12,12,0,0,1,12,0Z"
          fill={color}
          transform="translate(731.605 541.81)"
        />
        <path
          d="M0,39.052a3,3,0,0,1-3-3V0A3,3,0,0,1,0-3,3,3,0,0,1,3,0V36.052A3,3,0,0,1,0,39.052Z"
          fill={color}
          transform="translate(908.298 682.182)"
        />
        <path
          d="M9.013,0H55.04a9.013,9.013,0,0,1,0,18.026H9.013A9.013,9.013,0,0,1,9.013,0Z"
          fill="#d6d6e3"
          transform="translate(731.792 691.195)"
        />
        <path
          d="M9.013,0H77.572a9.013,9.013,0,1,1,0,18.026H9.013A9.013,9.013,0,0,1,9.013,0Z"
          fill="#d6d6e3"
          transform="translate(808.403 691.195)"
        />
        <path
          d="M9.5,0h62a9.5,9.5,0,0,1,0,19H9.5a9.5,9.5,0,0,1,0-19Z"
          fill="#d6d6e3"
          transform="translate(731.605 648.81)"
        />
        <path
          d="M9.5,0h78a9.5,9.5,0,0,1,0,19H9.5a9.5,9.5,0,0,1,0-19Z"
          fill="#d6d6e3"
          transform="translate(818.605 648.81)"
        />
        <path
          d="M9.5,0h62a9.5,9.5,0,0,1,0,19H9.5a9.5,9.5,0,0,1,0-19Z"
          fill="#d6d6e3"
          transform="translate(921.605 648.81)"
        />
        <path
          d="M9.5,0h125a9.5,9.5,0,0,1,0,19H9.5a9.5,9.5,0,0,1,0-19Z"
          fill="#d6d6e3"
          transform="translate(1008.605 648.81)"
        />
        <path
          d="M9,0H88a9,9,0,0,1,0,18H9A9,9,0,0,1,9,0Z"
          fill="#d6d6e3"
          transform="translate(731.605 608.81)"
        />
        <path
          d="M9,0H73a9,9,0,0,1,0,18H9A9,9,0,0,1,9,0Z"
          fill="#d6d6e3"
          transform="translate(833.605 608.81)"
        />
        <path
          d="M9,0H135a9,9,0,0,1,0,18H9A9,9,0,0,1,9,0Z"
          fill="#d6d6e3"
          transform="translate(921.605 608.81)"
        />
        <path
          d="M9,0H72a9,9,0,0,1,0,18H9A9,9,0,0,1,9,0Z"
          fill="#d6d6e3"
          transform="translate(1071.606 608.81)"
        />
      </g>
    </svg>
  );
};
